












































































































































/* eslint-disable */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import ApiPlans from '@finx/web-repository/src/apis/Plans/Plans'
import { IuguCreditCard } from '@finx/web-repository/src/types/Iugu'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import PagamentoStore from '@finx/web-repository/src/stores/Pagamento'
import AssinaturaStore from '@/store/Assinaturas'
import PagamentoStepsStore from '@/store/PagamentoSteps'

const component: Object = {
  store: {
    AssinaturaStore,
    PagamentoStepsStore,
    PagamentoStore,
  },
}

@Component(component)

export default class ViewPagamento extends Vue {
  isEquipeMedica: Boolean = false
  plan: any = {}
  plans: any = {}

  showAlertAlterar: Boolean = false
  showAlertAtivar: Boolean = false
  showAlertRegularizar: Boolean = false

  stores: any = {
    assinaturas: (this.$store as any).AssinaturaStore,
    steps: (this.$store as any).PagamentoStepsStore,
    pagamento: (this.$store as any).PagamentoStore,
  }

  get acao() {
    return this.stores.pagamento.getters.ACAO
  }

  get assinatura() {
    return this.stores.assinaturas.getters.ASSINATURA
  }

  mounted() {
    this.setAcao()
    this.getAssinatura()

    this.stores.steps.commit('STEP_ATIVA', 1)
  }

  async getAssinatura() {
    await AssinaturaStore.dispatch('GET_ASSINATURA')

    this.setUserType()
  }

  logout(): void {
    this.$router.push('/logout')
  }

  setAcao() {
    const path = this.$route.fullPath
    const acao = path.split('/')[2]

    this.stores.pagamento.commit('ACAO', acao)
  }

  setUserType() {
    if (this.assinatura.planos.length > 1) {
      this.plans = this.assinatura.planos
      this.isEquipeMedica = true
    } else {
      this.plan = this.assinatura.planos[0]
    }
  }

  showSuccessAlert(acao) {
    switch (acao) {
      case 'alterar': this.showAlertAlterar = true
        break

      case 'ativar': this.showAlertAtivar = true
        break

      case 'regularizar': this.showAlertRegularizar = true
        break

      default:
        break
    }

    this.stores.steps.commit('STEP_ATIVA', 1)
  }
}

